module.exports = __webpack_public_path__ + "media/newstyle/images/background-stores-be8c088669551d9b998dc75544e6da97.jpg";